(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sgg-m10-audited-cost"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sgg-audited-cost')) {
    class SggAuditedCost extends HTMLElement {
      connectedCallback() {
        try { this.costs = JSON.parse(this.dataset.costs || '{}'); } catch { this.costs = {}; }
        this.productForm = this.closest('.product-single-wrapper') || this.closest('#product-box');
        this.onVariantChanged = (event) => {
          if (event.detail?.product && String(event.detail.product.id) !== this.dataset.productId) return;
          const variant = event.detail?.variant;
          const match = variant && variant.requires_shipping ? this.costs[String(variant.id)] : null;
          const text = match && match.sku === (variant.sku || '') ? match.text : '';
          this.textContent = text;
          this.hidden = !text;
        };
        this.productForm?.addEventListener('variant:changed', this.onVariantChanged);
      }
      disconnectedCallback() {
        this.productForm?.removeEventListener('variant:changed', this.onVariantChanged);
      }
    }
    customElements.define('sgg-audited-cost', SggAuditedCost);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sgg-m10-delivery-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sgg-delivery-note')) {
    class SggDeliveryNote extends HTMLElement {
      connectedCallback() {
        try { this.costs = JSON.parse(this.dataset.costs || '{}'); } catch { this.costs = {}; }
        this.productForm = this.closest('.product-single-wrapper') || this.closest('#product-box');
        this.onVariantChanged = (event) => {
          if (event.detail?.product && String(event.detail.product.id) !== this.dataset.productId) return;
          const variant = event.detail?.variant;
          const token = variant ? '|' + variant.id + '=' + variant.sku + '=' + variant.weight + '|' : '';
          const allowed = Boolean(variant && variant.requires_shipping && this.dataset.special !== 'true' && this.dataset.expected.includes(token));
          this.dataset.state = allowed ? 'confirmed' : 'excluded';
          this.textContent = allowed ? this.dataset.confirmedText + (this.costs[token] ? ' ' + this.costs[token] : '') : this.dataset.otherText;
        };
        this.productForm?.addEventListener('variant:changed', this.onVariantChanged);
      }
      disconnectedCallback() {
        this.productForm?.removeEventListener('variant:changed', this.onVariantChanged);
      }
    }
    customElements.define('sgg-delivery-note', SggDeliveryNote);
  }
  } catch(e) { console.error(e); }
})();

})();
